import { TooltipPosition, TrainerData } from "../IronmonMapUtils";

export const defaultTrainerHeight = 22;
export const defaultTrainerWidth = 18;

export const trainers: TrainerData[] = [
  // Rt 103
  {
    name: "Rival",
    numPokemon: 1,
    pokemonLevels: [8],
    x: 2081,
    y: 3757,
  },
  {
    name: "Aroma Lady Daisy",
    numPokemon: 2,
    pokemonLevels: [23, 23],
    x: 3055,
    y: 3886,
    spinner: true,
  },
  {
    name: "Twins Amy & Liv",
    numPokemon: 2,
    pokemonLevels: [24, 24],
    x: 2947,
    y: 3906,
  },
  {
    name: "Pokefan Miguel",
    numPokemon: 1,
    pokemonLevels: [24],
    x: 2818,
    y: 3919,
  },
  {
    name: "Fisherman Andrew",
    numPokemon: 3,
    pokemonLevels: [8, 17, 24],
    x: 2719,
    y: 3857,
    walker: true,
  },
  {
    name: "Black Belt Rhett",
    numPokemon: 1,
    pokemonLevels: [24],
    x: 2992,
    y: 3791,
  },
  {
    name: "Guitarist Marcos",
    numPokemon: 1,
    pokemonLevels: [24],
    x: 2992,
    y: 3853,
  },

  // Rt 102
  {
    name: "Youngster Calvin",
    numPokemon: 1,
    pokemonLevels: [8],
    x: 1649,
    y: 4255,
  },
  {
    name: "Bug Catcher Rick",
    numPokemon: 2,
    pokemonLevels: [6, 6],
    x: 1520,
    y: 4272,
  },
  {
    name: "Youngster Allen",
    numPokemon: 2,
    pokemonLevels: [6, 5],
    x: 1423,
    y: 4095,
  },
  {
    name: "Lass Tiana",
    numPokemon: 2,
    pokemonLevels: [6, 6],
    x: 1249,
    y: 4143,
    spinner: true,
  },

  // Rt 104
  {
    name: "Youngster Billy",
    numPokemon: 2,
    pokemonLevels: [8, 11],
    x: 282,
    y: 4174,
    walker: true,
  },
  {
    name: "Fisherman Darian",
    numPokemon: 1,
    pokemonLevels: [15],
    x: 237,
    y: 4014,
  },
  {
    name: "Lady Cindy",
    numPokemon: 1,
    pokemonLevels: [11],
    x: 176,
    y: 3775,
    spinner: true,
  },
  {
    name: "Rich Boy Winston",
    numPokemon: 1,
    pokemonLevels: [11],
    x: 329,
    y: 3469,
    spinner: true,
  },
  {
    name: "Lass Haley",
    numPokemon: 2,
    pokemonLevels: [9, 9],
    x: 496,
    y: 3455,
  },
  {
    name: "Twins Gina & Mia",
    numPokemon: 2,
    pokemonLevels: [9, 9],
    x: 433,
    y: 3314,
  },
  {
    name: "Fisherman Ivan",
    numPokemon: 3,
    pokemonLevels: [8, 9, 11],
    x: 463,
    y: 3200,
  },

  // Petalburg Woods
  {
    name: "Bug Catcher Lyle",
    numPokemon: 4,
    pokemonLevels: [5, 5, 5, 5],
    x: 722,
    y: 3684,
    spinner: true,
  },
  {
    name: "Aqua Grunt",
    numPokemon: 1,
    pokemonLevels: [15],
    x: 1026,
    y: 3515,
  },
  {
    name: "Bug Catcher James",
    numPokemon: 2,
    pokemonLevels: [9, 9],
    x: 674,
    y: 3400,
    spinner: true,
  },

  // Rustboro City
  {
    name: "Rival",
    numPokemon: 2,
    pokemonLevels: [21, 24],
    x: 257,
    y: 2914,
  },

  // Rt 115
  {
    name: "Black Belt Nob",
    numPokemon: 1,
    pokemonLevels: [30],
    x: 432,
    y: 1683,
    spinner: true,
  },
  {
    name: "Battle Girl Cyndy",
    numPokemon: 2,
    pokemonLevels: [29, 29],
    x: 241,
    y: 1638,
  },
  {
    name: "Psychic Marlene",
    numPokemon: 2,
    pokemonLevels: [29, 29],
    x: 448,
    y: 1824,
    tooltipPosition: TooltipPosition.Bottom,
  },
  {
    name: "Collector Hector",
    numPokemon: 2,
    pokemonLevels: [29, 29],
    x: 384,
    y: 1824,
    spinner: true,
  },
  {
    name: "Black Belt Koichi",
    numPokemon: 2,
    pokemonLevels: [38, 45],
    x: 247,
    y: 1072,
    walker: true,
  },
  {
    name: "Triathlete Kyra",
    numPokemon: 2,
    pokemonLevels: [42, 42],
    x: 170,
    y: 1119,
    walker: true,
  },
  {
    name: "Ninja Boy Jaiden",
    numPokemon: 2,
    pokemonLevels: [42, 42],
    x: 178,
    y: 1026,
  },
  {
    name: "Expert Timothy",
    numPokemon: 1,
    pokemonLevels: [44],
    x: 81,
    y: 1069,
  },
  {
    name: "Battle Girl Helene",
    numPokemon: 2,
    pokemonLevels: [42, 42],
    x: 241,
    y: 943,
  },
  {
    name: "Psychic Alix",
    numPokemon: 2,
    pokemonLevels: [42, 42],
    x: 161,
    y: 943,
  },

  // Rt 116
  {
    name: "Bug Catcher Jose",
    numPokemon: 2,
    pokemonLevels: [12, 12],
    x: 849,
    y: 2383,
    spinner: true,
  },
  {
    name: "Youngster Joey",
    numPokemon: 1,
    pokemonLevels: [15],
    x: 834,
    y: 2226,
    spinner: true,
  },
  {
    name: "School Girl Karen",
    numPokemon: 1,
    pokemonLevels: [15],
    x: 993,
    y: 2369,
    spinner: true,
  },
  {
    name: "Youngster Johnson",
    numPokemon: 2,
    pokemonLevels: [12, 12],
    x: 1217,
    y: 2321,
    spinner: true,
  },
  {
    name: "Hiker Clark",
    numPokemon: 1,
    pokemonLevels: [12],
    x: 1217,
    y: 2383,
    spinner: true,
  },
  {
    name: "Hiker Devan",
    numPokemon: 2,
    pokemonLevels: [12, 12],
    x: 1313,
    y: 2320,
  },
  {
    name: "Lady Sarah",
    numPokemon: 2,
    pokemonLevels: [12, 12],
    x: 1168,
    y: 2237,
  },
  {
    name: "Rich Boy Dawson",
    numPokemon: 2,
    pokemonLevels: [12, 12],
    x: 1169,
    y: 2191,
  },
  {
    name: "Lass Janice",
    numPokemon: 1,
    pokemonLevels: [15],
    x: 1055,
    y: 2207,
  },
  {
    name: "School Kid Jerry",
    numPokemon: 1,
    pokemonLevels: [15],
    x: 1088,
    y: 2235,
    tooltipPosition: TooltipPosition.Bottom,
  },

  // Rusturf Tunnel
  {
    name: "Aqua Grunt",
    numPokemon: 1,
    pokemonLevels: [18],
    x: 1531,
    y: 2521,
  },
  {
    name: "Hiker Mike",
    numPokemon: 3,
    pokemonLevels: [26, 26, 26],
    x: 1838,
    y: 2650,
  },

  // Rt 106
  {
    name: "Fisherman Ned",
    numPokemon: 1,
    pokemonLevels: [18],
    x: 1043,
    y: 5855,
    spinner: true,
  },
  {
    name: "Fisherman Elliot",
    numPokemon: 3,
    pokemonLevels: [17, 11, 17],
    x: 817,
    y: 5856,
  },

  // Rt 109
  {
    name: "Sailor Huey",
    numPokemon: 2,
    pokemonLevels: [20, 20],
    x: 3439,
    y: 5581,
  },
  {
    name: "Tuber Hailey",
    numPokemon: 1,
    pokemonLevels: [21],
    x: 3471,
    y: 5524,
  },
  {
    name: "Tuber Ricky",
    numPokemon: 1,
    pokemonLevels: [21],
    x: 3504,
    y: 5479,
  },
  {
    name: "Tuber Lola",
    numPokemon: 2,
    pokemonLevels: [20, 20],
    x: 3551,
    y: 5429,
  },
  {
    name: "Tuber Chandler",
    numPokemon: 2,
    pokemonLevels: [20, 20],
    x: 3631,
    y: 5432,
  },
  {
    name: "Sailor Edmond",
    numPokemon: 1,
    pokemonLevels: [21],
    x: 3584,
    y: 5521,
  },

  // Seashore House
  // TODO: locations
  // ~3:27:00 of video
  /*
  {
    name: "Tuber Simon",
    numPokemon: 2,
    pokemonLevels: [20, 20],
    x: 0,
    y: 0,
  },
  {
    name: "Beauty Johanna",
    numPokemon: 1,
    pokemonLevels: [21],
    x: 0,
    y: 0,
  },
  {
    name: "Sailor Dwayne",
    numPokemon: 3,
    pokemonLevels: [18, 18, 18],
    x: 0,
    y: 0,
  },
  */

  // Oceanic Museum
  {
    name: "Aqua Grunt",
    numPokemon: 1,
    pokemonLevels: [24],
    x: 3892,
    y: 4770,
    tooltipPosition: TooltipPosition.Bottom,
  },
  {
    name: "Aqua Grunt",
    numPokemon: 2,
    pokemonLevels: [23, 23],
    x: 3893,
    y: 4752,
  },

  // Rt 110
  {
    name: "Pokefan Isabel",
    numPokemon: 2,
    pokemonLevels: [23, 23],
    x: 3363,
    y: 3962,
  },
  {
    name: "Pokefan Kaleb",
    numPokemon: 2,
    pokemonLevels: [23, 23],
    x: 3313,
    y: 3962,
    tooltipPosition: TooltipPosition.Bottom,
  },
  {
    name: "Youngster Timmy",
    numPokemon: 2,
    pokemonLevels: [24, 21],
    x: 3729,
    y: 3855,
    spinner: true,
  },
  {
    name: "Rival",
    numPokemon: 3,
    pokemonLevels: [29, 32, 20],
    x: 3744,
    y: 3600,
  },
  {
    name: "Collector Edwin",
    numPokemon: 2,
    pokemonLevels: [23, 23],
    x: 3745,
    y: 3393,
    tooltipPosition: TooltipPosition.Left,
  },
  {
    name: "Guitarist Joseph",
    numPokemon: 2,
    pokemonLevels: [23, 23],
    x: 3777,
    y: 3393,
    tooltipPosition: TooltipPosition.Right,
  },
  {
    name: "Triathlete Alyssa",
    numPokemon: 1,
    pokemonLevels: [24],
    x: 3354,
    y: 3375,
  },
  {
    name: "Psychic Edward",
    numPokemon: 1,
    pokemonLevels: [24],
    x: 3249,
    y: 3378,
  },
  {
    name: "Fisherman Dale",
    numPokemon: 4,
    pokemonLevels: [18, 23, 18, 23],
    x: 3360,
    y: 3055,
  },

  // Trick House
  {
    name: "Lass",
    numPokemon: 1,
    pokemonLevels: [26],
    x: 3181,
    y: 4349,
  },
  {
    name: "Youngster",
    numPokemon: 2,
    pokemonLevels: [23, 26],
    x: 3181,
    y: 4159,
  },
  {
    name: "Lass",
    numPokemon: 3,
    pokemonLevels: [23, 23, 23],
    x: 2987,
    y: 4270,
  },

  // Mauville
  {
    name: "Wally",
    numPokemon: 1,
    pokemonLevels: [26],
    x: 3328,
    y: 2531,
  },

  // Cycling Road
  {
    name: "Psychic Jaclyn",
    numPokemon: 1,
    pokemonLevels: [26],
    x: 3730,
    y: 2992,
  },
  {
    name: "Triathlete Abigail",
    numPokemon: 1,
    pokemonLevels: [26],
    x: 3675,
    y: 3250,
  },
  {
    name: "Triathlete Anthony",
    numPokemon: 2,
    pokemonLevels: [23, 23],
    x: 3383,
    y: 3232,
    walker: true,
  },
  {
    name: "Triathlete Benjamin",
    numPokemon: 1,
    pokemonLevels: [26],
    x: 3459,
    y: 3610,
    walker: true,
  },
  {
    name: "Triathlete Jasmine",
    numPokemon: 3,
    pokemonLevels: [23, 9, 23],
    x: 3456,
    y: 3865,
    walker: true,
  },
  {
    name: "Triathlete Jacob",
    numPokemon: 3,
    pokemonLevels: [9, 23, 9],
    x: 3505,
    y: 4000,
    walker: true,
  },

  // Rt 118
  {
    name: "Youngster Deandre",
    numPokemon: 3,
    pokemonLevels: [23, 23, 23],
    x: 3952,
    y: 2544,
  },
  {
    name: "Aroma Lady Rose",
    numPokemon: 3,
    pokemonLevels: [23, 23, 23],
    x: 3952,
    y: 2623,
  },
  {
    name: "Fisherman Wade",
    numPokemon: 1,
    pokemonLevels: [26],
    x: 4068,
    y: 2659,
  },
  {
    name: "Guitarist Dalton",
    numPokemon: 2,
    pokemonLevels: [24, 24],
    x: 4121,
    y: 2612,
  },
  // TODO: interviewers
  {
    name: "Fisherman Barny",
    numPokemon: 2,
    pokemonLevels: [41, 41],
    x: 4461,
    y: 2675,
    spinner: true,
  },

  // Rt 117
  {
    name: "Triathlete Dylan",
    numPokemon: 1,
    pokemonLevels: [27],
    x: 2910,
    y: 2688,
    walker: true,
  },
  {
    name: "Sr. and Jr. Anna & Meg",
    numPokemon: 2,
    pokemonLevels: [25, 27],
    x: 2912,
    y: 2528,
  },
  {
    name: "Pokemon Breeder Isaac",
    numPokemon: 6,
    pokemonLevels: [18, 18, 18, 18, 18, 18],
    x: 2769,
    y: 2607,
    spinner: true,
  },
  {
    name: "Triathlete Maria",
    numPokemon: 1,
    pokemonLevels: [27],
    x: 2643,
    y: 2607,
    walker: true,
  },
  {
    name: "Triathlete Melina",
    numPokemon: 1,
    pokemonLevels: [27],
    x: 2528,
    y: 2498,
    walker: true,
  },
  {
    name: "Battle Girl Aisha",
    numPokemon: 1,
    pokemonLevels: [27],
    x: 2577,
    y: 2498,
    tooltipPosition: TooltipPosition.Right,
  },
  {
    name: "Psychic Brandi",
    numPokemon: 1,
    pokemonLevels: [27],
    x: 2480,
    y: 2498,
    tooltipPosition: TooltipPosition.Left,
  },
  {
    name: "Bug Maniac Derek",
    numPokemon: 2,
    pokemonLevels: [26, 26],
    x: 2512,
    y: 2626,
  },
  {
    name: "Pokemon Breeder Lydia",
    numPokemon: 6,
    pokemonLevels: [18, 18, 18, 18, 18, 18],
    x: 2369,
    y: 2592,
    spinner: true,
  },

  // Rt 111
  {
    name: "Aroma Lady Celina",
    numPokemon: 1,
    pokemonLevels: [29],
    x: 3520,
    y: 2303,
  },
  {
    name: "Camper Tyron",
    numPokemon: 1,
    pokemonLevels: [30],
    x: 3616,
    y: 2303,
  },
  {
    name: "Picknicker Bianca",
    numPokemon: 1,
    pokemonLevels: [29],
    x: 3505,
    y: 2128,
  },
  {
    name: "Kindler Hayden",
    numPokemon: 1,
    pokemonLevels: [29],
    x: 3457,
    y: 2095,
  },
  {
    name: "Winstrate Victor",
    numPokemon: 2,
    pokemonLevels: [26, 26],
    x: 3409,
    y: 2015,
    tooltipPosition: TooltipPosition.Left,
  },
  {
    name: "Winstrate Victoria",
    numPokemon: 1,
    pokemonLevels: [27],
    x: 3425,
    y: 2015,
  },
  {
    name: "Winstrate Vivi",
    numPokemon: 3,
    pokemonLevels: [24, 24, 24],
    x: 3441,
    y: 2015,
    tooltipPosition: TooltipPosition.Bottom,
  },
  {
    name: "Winstrate Vicky",
    numPokemon: 1,
    pokemonLevels: [29],
    x: 3457,
    y: 2015,
    tooltipPosition: TooltipPosition.Right,
  },
  // TODO: Interviewer duo
  {
    name: "Picknicker Irene",
    numPokemon: 2,
    pokemonLevels: [27, 27],
    x: 3361,
    y: 1505,
    spinner: true,
  },
  {
    name: "Camper Travis",
    numPokemon: 1,
    pokemonLevels: [29],
    x: 3378,
    y: 1327,
    spinner: true,
  },
  {
    name: "Camper Larry",
    numPokemon: 1,
    pokemonLevels: [29],
    x: 3027,
    y: 1295,
  },
  {
    name: "Picknicker Carol",
    numPokemon: 2,
    pokemonLevels: [27, 27],
    x: 2912,
    y: 1248,
    spinner: true,
  },
  {
    name: "Hiker Trent",
    numPokemon: 3,
    pokemonLevels: [26, 27, 26],
    x: 2798,
    y: 1152,
    spinner: true,
  },
  {
    name: "Hiker Brice",
    numPokemon: 2,
    pokemonLevels: [27, 27],
    x: 2941,
    y: 1059,
    spinner: true,
  },

  // Rt 113
  {
    name: "Aroma Lady Shayla",
    numPokemon: 2,
    pokemonLevels: [29, 29],
    x: 3055,
    y: 688,
    spinner: true,
  },
  {
    name: "Kindler Bryant",
    numPokemon: 2,
    pokemonLevels: [29, 29],
    x: 3055,
    y: 624,
    spinner: true,
  },
  {
    name: "Cooltrainer Wilton",
    numPokemon: 3,
    pokemonLevels: [27, 27, 27],
    x: 3344,
    y: 627,
    spinner: true,
  },
  {
    name: "Black Belt Daisuke",
    numPokemon: 1,
    pokemonLevels: [30],
    x: 3718,
    y: 659,
    walker: true,
  },
  {
    name: "Cooltrainer Brooke",
    numPokemon: 3,
    pokemonLevels: [27, 27, 27],
    x: 3375,
    y: 370,
  },
  {
    name: "Youngster Jaylen",
    numPokemon: 1,
    pokemonLevels: [30],
    x: 2593,
    y: 320,
  },
  {
    name: "Ninja Boy Lung",
    numPokemon: 2,
    pokemonLevels: [29, 29],
    x: 2739,
    y: 230,
  },
  {
    name: "Camper Lawrence",
    numPokemon: 2,
    pokemonLevels: [29, 29],
    x: 2739,
    y: 257,
    tooltipPosition: TooltipPosition.Bottom,
  },
  {
    name: "Pokemaniac Wyatt",
    numPokemon: 2,
    pokemonLevels: [29, 29],
    x: 2800,
    y: 240,
    tooltipPosition: TooltipPosition.Right,
  },
  {
    name: "Parasol Lady Madeline",
    numPokemon: 1,
    pokemonLevels: [30],
    x: 2416,
    y: 369,
    spinner: true,
  },
  {
    name: "Twins Tori & Tia",
    numPokemon: 2,
    pokemonLevels: [30, 30],
    x: 2323,
    y: 290,
  },
  {
    name: "Ninja Boy Lao",
    numPokemon: 3,
    pokemonLevels: [27, 27, 27],
    x: 2065,
    y: 293,
  },
  {
    name: "Youngster Dillon",
    numPokemon: 1,
    pokemonLevels: [30],
    x: 1938,
    y: 368,
    spinner: true,
  },
  {
    name: "Picknicker Sophie",
    numPokemon: 2,
    pokemonLevels: [27, 30],
    x: 1712,
    y: 323,
    walker: true,
  },
  {
    name: "Bird Keeper Coby",
    numPokemon: 2,
    pokemonLevels: [27, 30],
    x: 1712,
    y: 382,
    walker: true,
  },

  // Rt 114
  {
    name: "Fisherman Nolan",
    numPokemon: 1,
    pokemonLevels: [30],
    x: 1040,
    y: 288,
  },
  {
    name: "Fisherman Kai",
    numPokemon: 1,
    pokemonLevels: [30],
    x: 1088,
    y: 449,
    spinner: true,
  },
  {
    name: "Picknicker Charlotte",
    numPokemon: 1,
    pokemonLevels: [30],
    x: 1088,
    y: 511,
  },
  {
    name: "Fisherman Claude",
    numPokemon: 3,
    pokemonLevels: [26, 27, 29],
    x: 944,
    y: 607,
  },
  {
    name: "Picknicker Nancy",
    numPokemon: 2,
    pokemonLevels: [29, 29],
    x: 944,
    y: 755,
    spinner: true,
  },
  {
    name: "Sr. and Jr. Tyra & Ivy",
    numPokemon: 2,
    pokemonLevels: [29, 31],
    x: 1008,
    y: 896,
  },
  {
    name: "Camper Shane",
    numPokemon: 2,
    pokemonLevels: [29, 29],
    x: 992,
    y: 990,
  },
  {
    name: "Pokemaniac Steve",
    numPokemon: 1,
    pokemonLevels: [30],
    x: 961,
    y: 1088,
  },
  {
    name: "Kindler Bernie",
    numPokemon: 2,
    pokemonLevels: [29, 29],
    x: 1121,
    y: 1120,
    spinner: true,
  },
  {
    name: "Hiker Lucas",
    numPokemon: 2,
    pokemonLevels: [29, 29],
    x: 1121,
    y: 1343,
    tooltipPosition: TooltipPosition.Right,
  },
  {
    name: "Picknicker Angelina",
    numPokemon: 2,
    pokemonLevels: [29, 29],
    x: 1055,
    y: 1343,
    spinner: true,
  },
  {
    name: "Hiker Lenny",
    numPokemon: 2,
    pokemonLevels: [29, 29],
    x: 878,
    y: 1231,
  },

  // Mt. Chimney
  {
    name: "Magma Grunt",
    numPokemon: 1,
    pokemonLevels: [32],
    x: 1976,
    y: 763,
  },
  {
    name: "Magma Grunt",
    numPokemon: 1,
    pokemonLevels: [32],
    x: 1908,
    y: 763,
    tooltipPosition: TooltipPosition.Left,
  },
  {
    name: "Magma Admin Tabitha",
    numPokemon: 4,
    pokemonLevels: [29, 32, 35, 35],
    x: 1962,
    y: 684,
  },
  {
    name: "Maxie",
    numPokemon: 6,
    pokemonLevels: [38, 38, 38, 38, 38, 41],
    x: 1978,
    y: 604,
  },

  // Jagged Pass
  {
    name: "Hiker Eric",
    numPokemon: 2,
    pokemonLevels: [32, 32],
    x: 1442,
    y: 639,
  },
  {
    name: "Magma Grunt",
    numPokemon: 2,
    pokemonLevels: [35, 35],
    x: 1537,
    y: 813,
  },
  {
    name: "Picknicker Diana",
    numPokemon: 3,
    pokemonLevels: [30, 30, 30],
    x: 1427,
    y: 849,
    spinner: true,
  },
  {
    name: "Picknicker Autumn",
    numPokemon: 1,
    pokemonLevels: [33],
    x: 1507,
    y: 911,
    spinner: true,
    tooltipPosition: TooltipPosition.Left,
  },
  {
    name: "Triathlete Julio",
    numPokemon: 1,
    pokemonLevels: [33],
    x: 1570,
    y: 910,
  },
  {
    name: "Camper Ethan",
    numPokemon: 2,
    pokemonLevels: [32, 32],
    x: 1536,
    y: 1073,
    spinner: true,
  },

  // Desert
  {
    name: "Camper Beau",
    numPokemon: 3,
    pokemonLevels: [33, 33, 33],
    x: 3532,
    y: 943,
  },
  {
    name: "Camper Drew",
    numPokemon: 1,
    pokemonLevels: [36],
    x: 3663,
    y: 784,
    spinner: true,
  },
  {
    name: "Camper Heidi",
    numPokemon: 2,
    pokemonLevels: [35, 35],
    x: 3646,
    y: 1008,
    spinner: true,
  },
  {
    name: "Camper Becky",
    numPokemon: 2,
    pokemonLevels: [35, 35],
    x: 3710,
    y: 1249,
    spinner: true,
  },
  {
    name: "Ruin Maniac Dusty",
    numPokemon: 1,
    pokemonLevels: [36],
    x: 3632,
    y: 1311,
    walker: true,
  },
  {
    name: "Picknicker Celia",
    numPokemon: 2,
    pokemonLevels: [35, 35],
    x: 3552,
    y: 1421,
  },
  {
    name: "Ruin Maniac Bryan",
    numPokemon: 2,
    pokemonLevels: [35, 35],
    x: 3667,
    y: 1421,
    spinner: true,
  },
  {
    name: "Camper Branden",
    numPokemon: 2,
    pokemonLevels: [35, 35],
    x: 3790,
    y: 1421,
  },

  // Rt 105
  {
    name: "Swimmer Imani",
    numPokemon: 1,
    pokemonLevels: [42],
    x: 305,
    y: 4500,
    spinner: true,
  },
  {
    name: "Swimmer Luis",
    numPokemon: 1,
    pokemonLevels: [42],
    x: 305,
    y: 5315,
  },
  {
    name: "Ruin Maniac Foster",
    numPokemon: 2,
    pokemonLevels: [41, 41],
    x: 274,
    y: 5159,
    walker: true,
  },
  {
    name: "Swimmer Beverly",
    numPokemon: 2,
    pokemonLevels: [41, 41],
    x: 134,
    y: 5015,
    walker: true,
  },
  {
    name: "Swimmer Dominik",
    numPokemon: 1,
    pokemonLevels: [42],
    x: 372,
    y: 4939,
    walker: true,
  },
  {
    name: "Ruin Maniac Andres",
    numPokemon: 2,
    pokemonLevels: [41, 41],
    x: 63,
    y: 5281,
  },
  {
    name: "Bird Keeper Josue",
    numPokemon: 2,
    pokemonLevels: [41, 41],
    x: 63,
    y: 5218,
  },

  // Rt 106
  {
    name: "Swimmer Douglas",
    numPokemon: 2,
    pokemonLevels: [38, 38],
    x: 274,
    y: 5721,
    walker: true,
  },
  {
    name: "Swimmer Kyla",
    numPokemon: 1,
    pokemonLevels: [42],
    x: 461,
    y: 5800,
  },

  // Rt 107
  {
    name: "Swimmer Denise",
    numPokemon: 2,
    pokemonLevels: [41, 41],
    x: 1536,
    y: 6074,
    spinner: true,
  },
  {
    name: "Swimmer Tony",
    numPokemon: 1,
    pokemonLevels: [42],
    x: 1672,
    y: 6135,
    walker: true,
  },
  {
    name: "Sis and Bro Lisa & Ray",
    numPokemon: 2,
    pokemonLevels: [44, 41],
    x: 1794,
    y: 6024,
  },
  {
    name: "Swimmer Darrin",
    numPokemon: 3,
    pokemonLevels: [38, 38, 38],
    x: 1939,
    y: 6123,
    spinner: true,
  },
  {
    name: "Triathlete Camron",
    numPokemon: 1,
    pokemonLevels: [42],
    x: 2079,
    y: 6036,
  },
  {
    name: "Swimmer Beth",
    numPokemon: 1,
    pokemonLevels: [42],
    x: 2079,
    y: 6134,
  },
  {
    name: "Swimmer Missy",
    numPokemon: 1,
    pokemonLevels: [42],
    x: 2365,
    y: 6067,
    spinner: true,
  },
  {
    name: "Swimmer Matthew",
    numPokemon: 1,
    pokemonLevels: [42],
    x: 2448,
    y: 6168,
    spinner: true,
  },
  {
    name: "Swimmer Tara",
    numPokemon: 2,
    pokemonLevels: [41, 41],
    x: 2797,
    y: 6151,
    spinner: true,
  },
  {
    name: "Cooltrainer Carolina",
    numPokemon: 3,
    pokemonLevels: [38, 38, 38],
    x: 2897,
    y: 6032,
  },
  {
    name: "Sailor Cory",
    numPokemon: 3,
    pokemonLevels: [38, 38, 38],
    x: 2931,
    y: 6032,
    tooltipPosition: TooltipPosition.Bottom,
  },
  {
    name: "Swimmer Jerome",
    numPokemon: 1,
    pokemonLevels: [42],
    x: 3074,
    y: 6104,
    walker: true,
  },
  {
    name: "Young Couple Mel & Paul",
    numPokemon: 2,
    pokemonLevels: [43, 43],
    x: 3326,
    y: 5964,
  },
  {
    name: "Swimmer David",
    numPokemon: 2,
    pokemonLevels: [41, 41],
    x: 3386,
    y: 5885,
  },
  {
    name: "Tuber Austina",
    numPokemon: 1,
    pokemonLevels: [42],
    x: 3650,
    y: 5813,
    spinner: true,
  },
  {
    name: "Tuber Gwen",
    numPokemon: 1,
    pokemonLevels: [42],
    x: 3666,
    y: 5829,
    spinner: true,
    tooltipPosition: TooltipPosition.Bottom,
  },
  {
    name: "Swimmer Alice",
    numPokemon: 3,
    pokemonLevels: [38, 38, 38],
    x: 3599,
    y: 5933,
    spinner: true,
  },
  {
    name: "Fisherman Carter",
    numPokemon: 2,
    pokemonLevels: [41, 41],
    x: 3534,
    y: 6207,
    tooltipPosition: TooltipPosition.Bottom,
  },
  {
    name: "Bird Keeper Elijah",
    numPokemon: 2,
    pokemonLevels: [41, 41],
    x: 3473,
    y: 6209,
  },

  // Rt 119
  {
    name: "Bird Keeper Chester",
    numPokemon: 2,
    pokemonLevels: [41, 41],
    x: 4736,
    y: 2543,
    spinner: true,
  },
  {
    name: "Bird Keeper Perry",
    numPokemon: 1,
    pokemonLevels: [42],
    x: 4864,
    y: 2592,
  },
  {
    name: "Bug Catcher Kent",
    numPokemon: 1,
    pokemonLevels: [41],
    x: 4722,
    y: 2235,
    walker: true,
  },
  {
    name: "Bug Maniac Donald",
    numPokemon: 3,
    pokemonLevels: [38, 38, 38],
    x: 4580,
    y: 2193,
    walker: true,
  },
  {
    name: "Bug Catcher Greg",
    numPokemon: 2,
    pokemonLevels: [41, 41],
    x: 4654,
    y: 2135,
    walker: true,
  },
  {
    name: "Bug Maniac Taylor",
    numPokemon: 3,
    pokemonLevels: [44, 44, 44],
    x: 4898,
    y: 2170,
    walker: true,
  },
  {
    name: "Bug Catcher Doug",
    numPokemon: 2,
    pokemonLevels: [45, 45],
    x: 5010,
    y: 2160,
    walker: true,
  },
  {
    name: "Bug Maniac Brent",
    numPokemon: 1,
    pokemonLevels: [42],
    x: 4916,
    y: 2068,
    walker: true,
  },
  {
    name: "Fisherman Chris",
    numPokemon: 4,
    pokemonLevels: [47, 32, 36, 42],
    x: 4690,
    y: 1853,
  },
  {
    name: "Pokemon Ranger Catherine",
    numPokemon: 2,
    pokemonLevels: [42, 42],
    x: 5040,
    y: 1520,
  },
  {
    name: "Pokemon Ranger Jackson",
    numPokemon: 1,
    pokemonLevels: [44],
    x: 4593,
    y: 1376,
    spinner: true,
  },
  {
    name: "Parasol Lady Rachel",
    numPokemon: 1,
    pokemonLevels: [42],
    x: 4608,
    y: 1282,
  },
  {
    name: "Bird Keeper Phil",
    numPokemon: 1,
    pokemonLevels: [42],
    x: 4608,
    y: 1201,
  },
  {
    name: "Kindler Dayton",
    numPokemon: 2,
    pokemonLevels: [41, 41],
    x: 4737,
    y: 1023,
  },
  {
    name: "Ninja Boy Takashi",
    numPokemon: 2,
    pokemonLevels: [41, 41],
    x: 4785,
    y: 981,
  },
  {
    name: "Bird Keeper Hugh",
    numPokemon: 2,
    pokemonLevels: [41, 41],
    x: 4642,
    y: 992,
  },
  {
    name: "Rival",
    numPokemon: 2,
    pokemonLevels: [47, 47, 50],
    x: 4880,
    y: 687,
  },
  {
    name: "Guitarist Fabian",
    numPokemon: 1,
    pokemonLevels: [42],
    x: 4994,
    y: 434,
    tooltipPosition: TooltipPosition.Bottom,
  },
  {
    name: "Ninja Boy Yasu",
    numPokemon: 1,
    pokemonLevels: [42],
    x: 4929,
    y: 419,
  },
  {
    name: "Ninja Boy Hideo",
    numPokemon: 2,
    pokemonLevels: [41, 41],
    x: 4946,
    y: 291,
  },

  // Weather Institute
  {
    name: "Aqua Grunt",
    numPokemon: 1,
    pokemonLevels: [45],
    x: 4316,
    y: 770,
  },
  {
    name: "Aqua Grunt",
    numPokemon: 2,
    pokemonLevels: [44, 44],
    x: 4397,
    y: 739,
  },
  {
    name: "Aqua Grunt",
    numPokemon: 2,
    pokemonLevels: [44, 44],
    x: 4462,
    y: 608,
  },
  {
    name: "Aqua Grunt",
    numPokemon: 2,
    pokemonLevels: [44, 44],
    x: 4397,
    y: 608,
  },
  {
    name: "Aqua Grunt",
    numPokemon: 3,
    pokemonLevels: [42, 42, 42],
    x: 4316,
    y: 640,
    spinner: true,
  },
  {
    name: "Aqua Admin Shelly",
    numPokemon: 2,
    pokemonLevels: [45, 45],
    x: 4220,
    y: 609,
  },

  // Rt 120
  {
    name: "Parasol Lady Clarissa",
    numPokemon: 2,
    pokemonLevels: [45, 45],
    x: 6016,
    y: 286,
    spinner: true,
  },
  {
    name: "Bird Keeper Robert",
    numPokemon: 1,
    pokemonLevels: [47],
    x: 6272,
    y: 419,
  },
  {
    name: "Bird Keeper Colin",
    numPokemon: 2,
    pokemonLevels: [45, 45],
    x: 5841,
    y: 544,
    spinner: true,
  },
  {
    name: "Cooltrainer Leonel",
    numPokemon: 1,
    pokemonLevels: [48],
    x: 5985,
    y: 735,
  },
  {
    name: "Parasol Lady Angelica",
    numPokemon: 1,
    pokemonLevels: [48],
    x: 6050,
    y: 735,
    tooltipPosition: TooltipPosition.Bottom,
  },
  {
    name: "Battle Girl Callie",
    numPokemon: 2,
    pokemonLevels: [45, 45],
    x: 6064,
    y: 703,
  },
  {
    name: "Ninja Boy Riley",
    numPokemon: 2,
    pokemonLevels: [45, 45],
    x: 6064,
    y: 643,
  },
  {
    name: "Cooltrainer Jennifer",
    numPokemon: 1,
    pokemonLevels: [48],
    x: 6255,
    y: 783,
    spinner: true,
  },
  {
    name: "Pokemon Ranger Jenna",
    numPokemon: 3,
    pokemonLevels: [45, 45, 45],
    x: 6337,
    y: 914,
  },
  {
    name: "Pokemon Ranger Lorenzo",
    numPokemon: 3,
    pokemonLevels: [45, 45, 45],
    x: 6193,
    y: 1008,
  },
  {
    name: "Bug Maniac Jeffery",
    numPokemon: 3,
    pokemonLevels: [44, 44, 44],
    x: 6064,
    y: 1472,
    spinner: true,
  },
  {
    name: "Ninja Boy Keigo",
    numPokemon: 2,
    pokemonLevels: [45, 45],
    x: 5921,
    y: 1348,
  },
  {
    name: "Ruin Maniac Chip",
    numPokemon: 3,
    pokemonLevels: [44, 44, 44],
    x: 5904,
    y: 1152,
    spinner: true,
  },

  // Rt 121
  {
    name: "Bug Maniac Cale",
    numPokemon: 2,
    pokemonLevels: [47, 47],
    x: 6576,
    y: 1569,
    walker: true,
  },
  {
    name: "Hex Maniac Tammy",
    numPokemon: 2,
    pokemonLevels: [47, 47],
    x: 6575,
    y: 1645,
  },
  {
    name: "Beauty Jessica",
    numPokemon: 2,
    pokemonLevels: [47, 47],
    x: 6752,
    y: 1553,
    spinner: true,
  },
  {
    name: "Sr. and Jr. Kate & Joy",
    numPokemon: 2,
    pokemonLevels: [48, 50],
    x: 7025,
    y: 1616,
  },
  {
    name: "Pokemon Breeder Myles",
    numPokemon: 6,
    pokemonLevels: [41, 41, 41, 41, 41, 41],
    x: 7344,
    y: 1598,
  },
  {
    name: "Pokemon Breeder Pat",
    numPokemon: 6,
    pokemonLevels: [41, 41, 41, 41, 41, 41],
    x: 7344,
    y: 1679,
  },
  {
    name: "Pokefan Vanessa",
    numPokemon: 1,
    pokemonLevels: [48],
    x: 7409,
    y: 1551,
  },
  {
    name: "Cooltrainer Marcel",
    numPokemon: 2,
    pokemonLevels: [47, 47],
    x: 7441,
    y: 1616,
    spinner: true,
  },
  {
    name: "Cooltrainer Cristin",
    numPokemon: 2,
    pokemonLevels: [47, 47],
    x: 7554,
    y: 1616,
    spinner: true,
  },
  {
    name: "Gentleman Walter",
    numPokemon: 1,
    pokemonLevels: [47],
    x: 7280,
    y: 1598,
    tooltipPosition: TooltipPosition.Left,
  },

  // Rt 123
  {
    name: "Bug Catcher Davis",
    numPokemon: 1,
    pokemonLevels: [44],
    x: 5345,
    y: 2641,
    walker: true,
  },
  {
    name: "Cooltrainer Jazmyn",
    numPokemon: 1,
    pokemonLevels: [44],
    x: 5345,
    y: 2691,
  },
  {
    name: "Aroma Lady Violet",
    numPokemon: 2,
    pokemonLevels: [42, 42],
    x: 5409,
    y: 2576,
    spinner: true,
  },
  {
    name: "Twins Miu & Yuki",
    numPokemon: 2,
    pokemonLevels: [42, 42],
    x: 5714,
    y: 2642,
  },
  {
    name: "Psychic Cameron",
    numPokemon: 1,
    pokemonLevels: [50],
    x: 7329,
    y: 2623,
  },
  {
    name: "Ninja Boy Jonas",
    numPokemon: 1,
    pokemonLevels: [50],
    x: 7329,
    y: 2658,
    tooltipPosition: TooltipPosition.Left,
  },
  {
    name: "Parasol Lady Kayley",
    numPokemon: 1,
    pokemonLevels: [50],
    x: 7329,
    y: 2688,
    tooltipPosition: TooltipPosition.Bottom,
  },
  {
    name: "Hex Maniac Kindra",
    numPokemon: 2,
    pokemonLevels: [48, 48],
    x: 6511,
    y: 2623,
  },
  {
    name: "Collector Ed",
    numPokemon: 2,
    pokemonLevels: [48, 48],
    x: 6511,
    y: 2705,
  },
  {
    name: "Cooltrainer Wendy",
    numPokemon: 3,
    pokemonLevels: [47, 47, 47],
    x: 6240,
    y: 2623,
    spinner: true,
  },
  {
    name: "Guitarist Fernando",
    numPokemon: 2,
    pokemonLevels: [48, 48],
    x: 6176,
    y: 2688,
  },
  {
    name: "Bird Keeper Alberto",
    numPokemon: 2,
    pokemonLevels: [48, 48],
    x: 6176,
    y: 2735,
  },
  {
    name: "Cooltrainer Braxton",
    numPokemon: 5,
    pokemonLevels: [45, 45, 45, 45, 45],
    x: 6049,
    y: 2545,
    spinner: true,
  },
  {
    name: "Psychic Jacki",
    numPokemon: 2,
    pokemonLevels: [48, 48],
    x: 5904,
    y: 2689,
  },
  {
    name: "Expert Fredrick",
    numPokemon: 2,
    pokemonLevels: [48, 48],
    x: 5904,
    y: 2736,
  },

  // Mt Pyre
  {
    name: "Pokemaniac Mark",
    numPokemon: 1,
    pokemonLevels: [50],
    x: 6983,
    y: 3694,
  },
  {
    name: "Hex Maniac Leah",
    numPokemon: 1,
    pokemonLevels: [50],
    x: 7031,
    y: 3694,
    spinner: true,
    tooltipPosition: TooltipPosition.Right,
  },
  {
    name: "Black Belt Zander",
    numPokemon: 1,
    pokemonLevels: [50],
    x: 7031,
    y: 3742,
    tooltipPosition: TooltipPosition.Bottom,
  },
  {
    name: "Young Couple Dez & Luke",
    numPokemon: 2,
    pokemonLevels: [50, 50],
    x: 6964,
    y: 3741,
  },
  {
    name: "Psychic Kayla",
    numPokemon: 3,
    pokemonLevels: [42, 42, 42],
    x: 7110,
    y: 3454,
    spinner: true,
    tooltipPosition: TooltipPosition.Right,
  },
  {
    name: "Pokemon Breeder Gabrielle",
    numPokemon: 6,
    pokemonLevels: [42, 42, 42, 42, 42, 42],
    x: 7032,
    y: 3454,
    spinner: true,
  },
  {
    name: "Psychic William",
    numPokemon: 3,
    pokemonLevels: [42, 42, 42],
    x: 6952,
    y: 3454,
    spinner: true,
    tooltipPosition: TooltipPosition.Left,
  },
  {
    name: "Hex Maniac Tasha",
    numPokemon: 1,
    pokemonLevels: [51],
    x: 7114,
    y: 3295,
    spinner: true,
  },
  {
    name: "Black Belt Atsushi",
    numPokemon: 1,
    pokemonLevels: [51],
    x: 6987,
    y: 3083,
    spinner: true,
  },
  {
    name: "Hex Maniac Valerie",
    numPokemon: 1,
    pokemonLevels: [51],
    x: 7031,
    y: 2813,
    spinner: true,
  },
  {
    name: "Psychic Cedric",
    numPokemon: 1,
    pokemonLevels: [51],
    x: 7096,
    y: 2813,
    spinner: true,
    tooltipPosition: TooltipPosition.Bottom,
  },

  // Mt Pyre Outside
  {
    name: "Aqua Grunt",
    numPokemon: 1,
    pokemonLevels: [51],
    x: 7551,
    y: 3051,
  },
  {
    name: "Aqua Grunt",
    numPokemon: 1,
    pokemonLevels: [51],
    x: 7488,
    y: 3003,
  },
  {
    name: "Aqua Grunt",
    numPokemon: 2,
    pokemonLevels: [48, 48],
    x: 7488,
    y: 2937,
  },
  {
    name: "Aqua Grunt",
    numPokemon: 2,
    pokemonLevels: [48, 48],
    x: 7553,
    y: 2938,
  },

  // Magma Hideout
  {
    name: "Magma Grunt",
    numPokemon: 1,
    pokemonLevels: [47],
    x: 4327,
    y: 3075,
  },
  {
    name: "Magma Grunt",
    numPokemon: 1,
    pokemonLevels: [47],
    x: 4739,
    y: 2914,
  },
  {
    name: "Magma Grunt",
    numPokemon: 1,
    pokemonLevels: [47],
    x: 4537,
    y: 2867,
  },
  {
    name: "Magma Grunt",
    numPokemon: 2,
    pokemonLevels: [45, 45],
    x: 4618,
    y: 3007,
    walker: true,
    tooltipPosition: TooltipPosition.Bottom,
  },
  {
    name: "Magma Grunt",
    numPokemon: 2,
    pokemonLevels: [45, 45],
    x: 4596,
    y: 3001,
    walker: true,
  },
  {
    name: "Magma Grunt",
    numPokemon: 1,
    pokemonLevels: [47],
    x: 4940,
    y: 2992,
  },
  {
    name: "Magma Grunt",
    numPokemon: 1,
    pokemonLevels: [47],
    x: 5244,
    y: 3217,
  },
  {
    name: "Magma Grunt",
    numPokemon: 1,
    pokemonLevels: [47],
    x: 5411,
    y: 3540,
  },
  {
    name: "Magma Grunt",
    numPokemon: 1,
    pokemonLevels: [47],
    x: 5425,
    y: 3477,
  },
  {
    name: "Magma Grunt",
    numPokemon: 1,
    pokemonLevels: [47],
    x: 5863,
    y: 3196,
  },
  {
    name: "Magma Grunt",
    numPokemon: 1,
    pokemonLevels: [47],
    x: 5849,
    y: 3049,
  },
  {
    name: "Magma Grunt",
    numPokemon: 1,
    pokemonLevels: [47],
    x: 5785,
    y: 3049,
    tooltipPosition: TooltipPosition.Bottom,
  },
  {
    name: "Magma Admin Tabitha",
    numPokemon: 4,
    pokemonLevels: [42, 48, 45, 53],
    x: 5720,
    y: 2907,
  },
  {
    name: "Magma Grunt",
    numPokemon: 1,
    pokemonLevels: [47],
    x: 5698,
    y: 3511,
  },
  {
    name: "Magma Grunt",
    numPokemon: 1,
    pokemonLevels: [47],
    x: 5765,
    y: 3462,
  },
  {
    name: "Magma Grunt",
    numPokemon: 1,
    pokemonLevels: [47],
    x: 3907,
    y: 2834,
  },
  {
    name: "Maxie",
    numPokemon: 6,
    pokemonLevels: [59, 59, 60, 59, 59, 62],
    x: 5619,
    y: 3179,
  },

  // Aqua Hideout
  {
    name: "Aqua Grunt",
    numPokemon: 1,
    pokemonLevels: [51],
    x: 8842,
    y: 922,
    walker: true,
  },
  {
    name: "Aqua Grunt",
    numPokemon: 1,
    pokemonLevels: [51],
    x: 9280,
    y: 1040,
    spinner: true,
  },
  {
    name: "Aqua Grunt",
    numPokemon: 2,
    pokemonLevels: [50, 50],
    x: 9406,
    y: 1086,
  },
  {
    name: "Aqua Grunt",
    numPokemon: 2,
    pokemonLevels: [50, 50],
    x: 9406,
    y: 1006,
  },
  {
    name: "Aqua Grunt",
    numPokemon: 1,
    pokemonLevels: [51],
    x: 10118,
    y: 863,
    walker: true,
  },
  {
    name: "Aqua Grunt",
    numPokemon: 1,
    pokemonLevels: [51],
    x: 9058,
    y: 848,
  },
  {
    name: "Aqua Grunt",
    numPokemon: 1,
    pokemonLevels: [51],
    x: 9992,
    y: 827,
  },
  {
    name: "Aqua Grunt",
    numPokemon: 1,
    pokemonLevels: [51],
    x: 9894,
    y: 827,
  },
  {
    name: "Aqua Admin Matt",
    numPokemon: 2,
    pokemonLevels: [54, 54],
    x: 10149,
    y: 1054,
  },

  // Lilycove City
  {
    name: "Rival",
    numPokemon: 4,
    pokemonLevels: [50, 51, 51, 54],
    x: 8113,
    y: 1421,
  },

  // Rt 124
  {
    name: "Swimmer Grace",
    numPokemon: 1,
    pokemonLevels: [54],
    x: 9072,
    y: 1507,
    spinner: true,
  },
  {
    name: "Swimmer Declan",
    numPokemon: 1,
    pokemonLevels: [54],
    x: 9072,
    y: 1603,
  },
  {
    name: "Swimmer Spencer",
    numPokemon: 2,
    pokemonLevels: [53, 53],
    x: 9509,
    y: 1523,
    spinner: true,
  },
  {
    name: "Sis and Bro Lila & Roy",
    numPokemon: 2,
    pokemonLevels: [54, 53],
    x: 9234,
    y: 1836,
  },
  {
    name: "Swimmer Jenny",
    numPokemon: 1,
    pokemonLevels: [54],
    x: 9709,
    y: 1856,
    spinner: true,
  },
  {
    name: "Swimmer Chad",
    numPokemon: 2,
    pokemonLevels: [53, 53],
    x: 9959,
    y: 2063,
    walker: true,
  },
  {
    name: "Swimmer Roland",
    numPokemon: 1,
    pokemonLevels: [54],
    x: 9938,
    y: 2326,
  },
  {
    name: "Triathlete Isabella",
    numPokemon: 1,
    pokemonLevels: [54],
    x: 10063,
    y: 2326,
  },

  // Rt 125
  {
    name: "Sailor Ernest",
    numPokemon: 2,
    pokemonLevels: [53, 53],
    x: 10576,
    y: 1618,
    spinner: true,
  },
  {
    name: "Swimmer Nolen",
    numPokemon: 1,
    pokemonLevels: [54],
    x: 10388,
    y: 1628,
    walker: true,
  },
  {
    name: "Swimmer Sharon",
    numPokemon: 1,
    pokemonLevels: [54],
    x: 10760,
    y: 1600,
    walker: true,
  },
  {
    name: "Swimmer Tanya",
    numPokemon: 1,
    pokemonLevels: [54],
    x: 10887,
    y: 1526,
    walker: true,
  },
  {
    name: "Bird Keeper Presley",
    numPokemon: 2,
    pokemonLevels: [53, 53],
    x: 10934,
    y: 1441,
    walker: true,
  },
  {
    name: "Expert Auron",
    numPokemon: 2,
    pokemonLevels: [53, 53],
    x: 11001,
    y: 1441,
    walker: true,
    tooltipPosition: TooltipPosition.Bottom,
  },
  {
    name: "Swimmer Stan",
    numPokemon: 1,
    pokemonLevels: [54],
    x: 10963,
    y: 1290,
  },
  {
    name: "Sr. and Jr. Kim & Iris",
    numPokemon: 2,
    pokemonLevels: [52, 55],
    x: 10512,
    y: 1440,
  },

  // Mossdeep Space Center
  {
    name: "Magma Grunt",
    numPokemon: 2,
    pokemonLevels: [50, 50],
    x: 11571,
    y: 2189,
    tooltipPosition: TooltipPosition.Bottom,
  },
  {
    name: "Magma Grunt",
    numPokemon: 1,
    pokemonLevels: [51],
    x: 11557,
    y: 2139,
  },
  {
    name: "Magma Grunt",
    numPokemon: 1,
    pokemonLevels: [51],
    x: 11539,
    y: 2076,
  },
  {
    name: "Magma Grunt",
    numPokemon: 3,
    pokemonLevels: [42, 45, 48],
    x: 11586,
    y: 2076,
    tooltipPosition: TooltipPosition.Right,
  },
  {
    name: "Magma Grunt",
    numPokemon: 1,
    pokemonLevels: [51],
    x: 11586,
    y: 1932,
    tooltipPosition: TooltipPosition.Bottom,
  },
  {
    name: "Magma Grunt",
    numPokemon: 1,
    pokemonLevels: [51],
    x: 11570,
    y: 1915,
    tooltipPosition: TooltipPosition.Left,
  },
  {
    name: "Magma Grunt",
    numPokemon: 1,
    pokemonLevels: [51],
    x: 11603,
    y: 1915,
  },
  {
    name: "Maxie & Magma Admin Tabitha",
    numPokemon: 6,
    pokemonLevels: [57, 60, 63, 68, 69, 71],
    x: 11393,
    y: 2029,
  },

  // Rt 126
  {
    name: "Swimmer Dean",
    numPokemon: 3,
    pokemonLevels: [50, 50, 50],
    x: 9904,
    y: 2775,
    walker: true,
  },
  {
    name: "Swimmer Sienna",
    numPokemon: 2,
    pokemonLevels: [53, 53],
    x: 9200,
    y: 3473,
  },
  {
    name: "Triathlete Pablo",
    numPokemon: 2,
    pokemonLevels: [53, 53],
    x: 9071,
    y: 3473,
  },
  {
    name: "Swimmer Barry",
    numPokemon: 1,
    pokemonLevels: [54],
    x: 9726,
    y: 3461,
    walker: true,
  },
  {
    name: "Swimmer Nikki",
    numPokemon: 2,
    pokemonLevels: [53, 53],
    x: 9962,
    y: 3107,
    spinner: true,
  },
  {
    name: "Swimmer Brenda",
    numPokemon: 1,
    pokemonLevels: [54],
    x: 9104,
    y: 3190,
  },
  {
    name: "Swimmer Leonardo",
    numPokemon: 1,
    pokemonLevels: [54],
    x: 9854,
    y: 2503,
  },
  {
    name: "Triathlete Isobel",
    numPokemon: 1,
    pokemonLevels: [54],
    x: 9983,
    y: 2503,
  },

  // Rt 127
  {
    name: "Cooltrainer Athena",
    numPokemon: 2,
    pokemonLevels: [51, 51],
    x: 10430,
    y: 2783,
    tooltipPosition: TooltipPosition.Bottom,
  },
  {
    name: "Bird Keeper Aidan",
    numPokemon: 2,
    pokemonLevels: [51, 51],
    x: 10481,
    y: 2783,
  },
  {
    name: "Triathlete Donny",
    numPokemon: 2,
    pokemonLevels: [42, 54],
    x: 10528,
    y: 3506,
    spinner: true,
  },
  {
    name: "Triathlete Camden",
    numPokemon: 2,
    pokemonLevels: [53, 53],
    x: 10958,
    y: 3085,
    spinner: true,
  },
  {
    name: "Fisherman Jonah",
    numPokemon: 3,
    pokemonLevels: [48, 50, 51],
    x: 10912,
    y: 2753,
  },
  {
    name: "Fisherman Henry",
    numPokemon: 2,
    pokemonLevels: [50, 54],
    x: 11108,
    y: 2639,
  },
  {
    name: "Fisherman Roger",
    numPokemon: 3,
    pokemonLevels: [24, 56, 41],
    x: 11265,
    y: 2720,
  },
  {
    name: "Black Belt Koji",
    numPokemon: 1,
    pokemonLevels: [54],
    x: 11243,
    y: 3426,
    spinner: true,
  },

  // Rt 128
  {
    name: "Cooltrainer Alexa",
    numPokemon: 2,
    pokemonLevels: [54, 54],
    x: 10627,
    y: 3823,
    spinner: true,
  },
  {
    name: "Cooltrainer Ruben",
    numPokemon: 2,
    pokemonLevels: [54, 54],
    x: 10994,
    y: 3840,
  },
  {
    name: "Triathlete Katelyn",
    numPokemon: 1,
    pokemonLevels: [56],
    x: 11488,
    y: 4087,
    walker: true,
  },
  {
    name: "Fisherman Wayne",
    numPokemon: 3,
    pokemonLevels: [50, 57, 50],
    x: 11249,
    y: 4144,
  },
  {
    name: "Swimmer Harrison",
    numPokemon: 1,
    pokemonLevels: [56],
    x: 11857,
    y: 4070,
    walker: true,
  },
  {
    name: "Swimmer Carlee",
    numPokemon: 1,
    pokemonLevels: [56],
    x: 11857,
    y: 4139,
    walker: true,
  },
  {
    name: "Triathlete Isaiah",
    numPokemon: 1,
    pokemonLevels: [56],
    x: 10881,
    y: 4187,
    walker: true,
  },

  // Rt 129
  {
    name: "Swimmer Reed",
    numPokemon: 2,
    pokemonLevels: [53, 53],
    x: 10791,
    y: 4486,
    spinner: true,
  },
  {
    name: "Triathlete Chase",
    numPokemon: 2,
    pokemonLevels: [42, 54],
    x: 10687,
    y: 4615,
    walker: true,
  },
  {
    name: "Swimmer Tisha",
    numPokemon: 1,
    pokemonLevels: [54],
    x: 10445,
    y: 4691,
  },
  {
    name: "Swimmer Clarence",
    numPokemon: 1,
    pokemonLevels: [54],
    x: 10445,
    y: 4773,
  },
  {
    name: "Triathlete Allison",
    numPokemon: 2,
    pokemonLevels: [44, 53],
    x: 10461,
    y: 4598,
    walker: true,
  },

  // Rt 130
  {
    name: "Swimmer Rodney",
    numPokemon: 1,
    pokemonLevels: [54],
    x: 10080,
    y: 4589,
    walker: true,
  },
  {
    name: "Swimmer Katie",
    numPokemon: 2,
    pokemonLevels: [53, 53],
    x: 9071,
    y: 4694,
    walker: true,
  },
  {
    name: "Swimmer Santiago",
    numPokemon: 2,
    pokemonLevels: [53, 53],
    x: 9071,
    y: 4770,
    walker: true,
  },

  // Rt 131
  {
    name: "Triathlete Talia",
    numPokemon: 1,
    pokemonLevels: [54],
    x: 8828,
    y: 4744,
    walker: true,
  },
  {
    name: "Swimmer Kevin",
    numPokemon: 1,
    pokemonLevels: [54],
    x: 8828,
    y: 4687,
    walker: true,
  },
  {
    name: "Swimmer Richard",
    numPokemon: 1,
    pokemonLevels: [54],
    x: 8664,
    y: 4753,
    walker: true,
  },
  {
    name: "Swimmer Kara",
    numPokemon: 1,
    pokemonLevels: [54],
    x: 8444,
    y: 4787,
    walker: true,
  },
  {
    name: "Swimmer Susie",
    numPokemon: 1,
    pokemonLevels: [54],
    x: 8148,
    y: 4692,
    spinner: true,
  },
  {
    name: "Sis and Bro Reli & Ian",
    numPokemon: 1,
    pokemonLevels: [54],
    x: 8131,
    y: 4597,
  },
  {
    name: "Swimmer Herman",
    numPokemon: 2,
    pokemonLevels: [53, 53],
    x: 8291,
    y: 4640,
    spinner: true,
  },

  // Rt 132
  {
    name: "Fisherman Ronald",
    numPokemon: 6,
    pokemonLevels: [30, 33, 36, 42, 48, 56],
    x: 7184,
    y: 4784,
  },
  {
    name: "Swimmer Gilbert",
    numPokemon: 1,
    pokemonLevels: [54],
    x: 7072,
    y: 4588,
    walker: true,
  },
  {
    name: "Swimmer Dana",
    numPokemon: 1,
    pokemonLevels: [54],
    x: 6535,
    y: 4438,
    walker: true,
  },
  {
    name: "Black Belt Kiyo",
    numPokemon: 1,
    pokemonLevels: [54],
    x: 6544,
    y: 4575,
  },
  {
    name: "Cooltrainer Darcy",
    numPokemon: 2,
    pokemonLevels: [53, 53],
    x: 6925,
    y: 4793,
    walker: true,
  },
  {
    name: "Expert Paxton",
    numPokemon: 2,
    pokemonLevels: [53, 53],
    x: 6925,
    y: 4751,
  },
  {
    name: "Expert Makayla",
    numPokemon: 2,
    pokemonLevels: [53, 53],
    x: 6736,
    y: 4818,
  },
  {
    name: "Cooltrainer Johnathan",
    numPokemon: 2,
    pokemonLevels: [53, 53],
    x: 6736,
    y: 4768,
    walker: true,
  },

  // Rt 133
  {
    name: "Cooltrainer Warren",
    numPokemon: 2,
    pokemonLevels: [53, 53],
    x: 5708,
    y: 4577,
    spinner: true,
  },
  {
    name: "Expert Mollie",
    numPokemon: 2,
    pokemonLevels: [53, 53],
    x: 6015,
    y: 4510,
  },
  {
    name: "Expert Conor",
    numPokemon: 2,
    pokemonLevels: [53, 53],
    x: 6015,
    y: 4580,
    spinner: true,
  },
  {
    name: "Swimmer Linda",
    numPokemon: 2,
    pokemonLevels: [53, 53],
    x: 5330,
    y: 4390,
  },
  {
    name: "Bird Keeper Beck",
    numPokemon: 1,
    pokemonLevels: [54],
    x: 5243,
    y: 4559,
    spinner: true,
  },
  {
    name: "Swimmer Franklin",
    numPokemon: 1,
    pokemonLevels: [54],
    x: 6206,
    y: 4748,
    walker: true,
  },
  {
    name: "Swimmer Debra",
    numPokemon: 1,
    pokemonLevels: [54],
    x: 6206,
    y: 4813,
    walker: true,
  },

  // Rt 134
  {
    name: "Swimmer Laurel",
    numPokemon: 2,
    pokemonLevels: [53, 53],
    x: 4767,
    y: 4452,
    spinner: true,
  },
  {
    name: "Swimmer Jack",
    numPokemon: 1,
    pokemonLevels: [54],
    x: 4668,
    y: 4485,
    walker: true,
  },
  {
    name: "Black Belt Hitoshi",
    numPokemon: 2,
    pokemonLevels: [51, 51],
    x: 4563,
    y: 4593,
    walker: true,
  },
  {
    name: "Battle Girl Reyna",
    numPokemon: 2,
    pokemonLevels: [53, 53],
    x: 4684,
    y: 4593,
    walker: true,
  },
  {
    name: "Dragon Tamer Aaron",
    numPokemon: 1,
    pokemonLevels: [54],
    x: 4497,
    y: 4706,
    tooltipPosition: TooltipPosition.Bottom,
  },
  {
    name: "Cooltrainer Marley",
    numPokemon: 1,
    pokemonLevels: [54],
    x: 4529,
    y: 4706,
  },
  {
    name: "Sailor Kelvin",
    numPokemon: 2,
    pokemonLevels: [53, 53],
    x: 4222,
    y: 4802,
    walker: true,
  },
  {
    name: "Bird Keeper Alex",
    numPokemon: 2,
    pokemonLevels: [53, 53],
    x: 4222,
    y: 4739,
    walker: true,
  },
  {
    name: "Sailor Hudson",
    numPokemon: 1,
    pokemonLevels: [54],
    x: 4849,
    y: 4560,
    spinner: true,
  },

  // Abandoned Ship
  {
    name: "Youngster Demetrius",
    numPokemon: 2,
    pokemonLevels: [41, 41],
    x: 2684,
    y: 5275,
    spinner: true,
  },
  {
    name: "Beauty Thalia",
    numPokemon: 2,
    pokemonLevels: [41, 41],
    x: 2684,
    y: 5195,
  },
  {
    name: "Sailor Duncan",
    numPokemon: 2,
    pokemonLevels: [41, 41],
    x: 2315,
    y: 5561,
    spinner: true,
  },
  {
    name: "Tuber Charlie",
    numPokemon: 1,
    pokemonLevels: [42],
    x: 2525,
    y: 5089,
    walker: true,
  },
  {
    name: "Tuber Jani",
    numPokemon: 1,
    pokemonLevels: [42],
    x: 2483,
    y: 4849,
    tooltipPosition: TooltipPosition.Bottom,
  },
  {
    name: "Ruin Maniac Garrison",
    numPokemon: 1,
    pokemonLevels: [42],
    x: 2416,
    y: 4849,
  },
  {
    name: "Young Couple Kira & Dan",
    numPokemon: 2,
    pokemonLevels: [41, 41],
    x: 2476,
    y: 5230,
  },

  // Seafloor Cavern
  {
    name: "Aqua Grunt",
    numPokemon: 1,
    pokemonLevels: [57],
    x: 8855,
    y: 4096,
    spinner: true,
  },
  {
    name: "Aqua Grunt",
    numPokemon: 1,
    pokemonLevels: [57],
    x: 8967,
    y: 4161,
    spinner: true,
  },
  {
    name: "Aqua Grunt",
    numPokemon: 2,
    pokemonLevels: [56, 56],
    x: 9811,
    y: 4105,
    tooltipPosition: TooltipPosition.Left,
  },
  {
    name: "Aqua Admin Shelly",
    numPokemon: 2,
    pokemonLevels: [59, 59],
    x: 9879,
    y: 4105,
  },
  {
    name: "Aqua Grunt",
    numPokemon: 1,
    pokemonLevels: [57],
    x: 9126,
    y: 4128,
    spinner: true,
  },
  {
    name: "Aqua Grunt",
    numPokemon: 1,
    pokemonLevels: [57],
    x: 9126,
    y: 4194,
  },
  {
    name: "Archie",
    numPokemon: 6,
    pokemonLevels: [65, 65, 65, 65, 65, 69],
    x: 10258,
    y: 4349,
  },

  // Victory Road
  {
    name: "Cooltrainer Albert",
    numPokemon: 2,
    pokemonLevels: [69, 69],
    x: 12477,
    y: 2866,
    spinner: true,
  },
  {
    name: "Wally",
    numPokemon: 5,
    pokemonLevels: [71, 69, 65, 71, 72],
    x: 12096,
    y: 2684,
  },
  {
    name: "Cooltrainer Hope",
    numPokemon: 1,
    pokemonLevels: [72],
    x: 12146,
    y: 2566,
  },
  {
    name: "Cooltrainer Shannon",
    numPokemon: 1,
    pokemonLevels: [72],
    x: 12461,
    y: 2069,
  },
  {
    name: "Cooltrainer Samuel",
    numPokemon: 3,
    pokemonLevels: [68, 68, 68],
    x: 12639,
    y: 2004,
  },
  {
    name: "Cooltrainer Julie",
    numPokemon: 3,
    pokemonLevels: [68, 68, 68],
    x: 12605,
    y: 1643,
  },
  {
    name: "Cooltrainer Owen",
    numPokemon: 3,
    pokemonLevels: [68, 68, 68],
    x: 12735,
    y: 1536,
  },
  {
    name: "Cooltrainer Dianne",
    numPokemon: 2,
    pokemonLevels: [69, 69],
    x: 12443,
    y: 1587,
  },
  {
    name: "Cooltrainer Felix",
    numPokemon: 2,
    pokemonLevels: [69, 69],
    x: 12443,
    y: 1631,
  },
  {
    name: "Cooltrainer Vito",
    numPokemon: 4,
    pokemonLevels: [68, 68, 68, 68],
    x: 12287,
    y: 1393,
  },
  {
    name: "Cooltrainer Michelle",
    numPokemon: 3,
    pokemonLevels: [68, 68, 68],
    x: 12126,
    y: 2147,
  },
  {
    name: "Cooltrainer Mitchell",
    numPokemon: 2,
    pokemonLevels: [69, 69],
    x: 12271,
    y: 2066,
  },
  {
    name: "Cooltrainer Halle",
    numPokemon: 2,
    pokemonLevels: [69, 69],
    x: 12271,
    y: 2133,
    spinner: true,
  },
  {
    name: "Cooltrainer Edgar",
    numPokemon: 2,
    pokemonLevels: [69, 69],
    x: 12575,
    y: 2675,
  },
  {
    name: "Cooltrainer Caroline",
    numPokemon: 2,
    pokemonLevels: [69, 69],
    x: 12078,
    y: 1568,
  },
  {
    name: "Cooltrainer Quincy",
    numPokemon: 2,
    pokemonLevels: [69, 69],
    x: 12561,
    y: 2594,
    tooltipPosition: TooltipPosition.Right,
  },
  {
    name: "Cooltrainer Katelynn",
    numPokemon: 2,
    pokemonLevels: [69, 69],
    x: 12509,
    y: 2594,
  },

  // Meteor Falls
  {
    name: "Old Couple John & Jay",
    numPokemon: 2,
    pokemonLevels: [62, 62],
    x: 1223,
    y: 1792,
  },
  {
    name: "Dragon Tamer Nicolas",
    numPokemon: 2,
    pokemonLevels: [59, 59],
    x: 1334,
    y: 1628,
  },
  {
    name: "Steven",
    numPokemon: 6,
    pokemonLevels: [100, 100, 100, 100, 100, 100],
    x: 2383,
    y: 1645,
  },

  // Rustboro Gym
  {
    name: "Youngster Josh",
    numPokemon: 1,
    pokemonLevels: [17],
    x: 682,
    y: 2614,
  },
  {
    name: "Youngster Tommy",
    numPokemon: 2,
    pokemonLevels: [12, 12],
    x: 651,
    y: 2550,
  },
  {
    name: "Hiker Marc",
    numPokemon: 2,
    pokemonLevels: [12, 12],
    x: 618,
    y: 2500,
  },
  {
    name: "Roxanne",
    numPokemon: 6,
    pokemonLevels: [20, 20, 20, 20, 20, 24],
    x: 683,
    y: 2438,
  },

  // Dewford Gym
  {
    name: "Battle Girl Laura",
    numPokemon: 1,
    pokemonLevels: [21],
    x: 861,
    y: 6356,
  },
  {
    name: "Battle Girl Lilith",
    numPokemon: 1,
    pokemonLevels: [21],
    x: 925,
    y: 6100,
  },
  {
    name: "Sailor Brenden",
    numPokemon: 1,
    pokemonLevels: [21],
    x: 894,
    y: 6148,
  },
  {
    name: "Black Belt Takao",
    numPokemon: 1,
    pokemonLevels: [21],
    x: 701,
    y: 6244,
  },
  {
    name: "Black Belt Cristian",
    numPokemon: 1,
    pokemonLevels: [21],
    x: 782,
    y: 6084,
  },
  {
    name: "Battle Girl Jocelyn",
    numPokemon: 1,
    pokemonLevels: [21],
    x: 910,
    y: 6005,
  },
  {
    name: "Brawly",
    numPokemon: 6,
    pokemonLevels: [26, 26, 26, 26, 26, 30],
    x: 733,
    y: 6005,
  },

  // Mauville Gym
  {
    name: "Battle Girl Vivian",
    numPokemon: 2,
    pokemonLevels: [27, 27],
    x: 3135,
    y: 2410,
  },
  {
    name: "Guitarist Kirk",
    numPokemon: 2,
    pokemonLevels: [27, 27],
    x: 3135,
    y: 2362,
  },
  {
    name: "Youngster Ben",
    numPokemon: 2,
    pokemonLevels: [27, 27],
    x: 3199,
    y: 2315,
  },
  {
    name: "Bug Maniac Angelo",
    numPokemon: 2,
    pokemonLevels: [27, 27],
    x: 3230,
    y: 2314,
    tooltipPosition: TooltipPosition.Bottom,
  },
  {
    name: "Guitarist Shawn",
    numPokemon: 2,
    pokemonLevels: [27, 27],
    x: 3230,
    y: 2282,
  },
  {
    name: "Wattson",
    numPokemon: 6,
    pokemonLevels: [32, 35, 32, 32, 32, 38],
    x: 3199,
    y: 2188,
  },

  // Petalburg Gym
  {
    name: "Cooltrainer Randall",
    numPokemon: 1,
    pokemonLevels: [42],
    x: 1544,
    y: 3777,
  },
  {
    name: "Cooltrainer Mary",
    numPokemon: 1,
    pokemonLevels: [42],
    x: 1720,
    y: 3777,
  },
  {
    name: "Cooltrainer Parker",
    numPokemon: 1,
    pokemonLevels: [42],
    x: 1455,
    y: 3626,
  },
  {
    name: "Cooltrainer Alexia",
    numPokemon: 1,
    pokemonLevels: [42],
    x: 1630,
    y: 3626,
  },
  {
    name: "Cooltrainer George",
    numPokemon: 1,
    pokemonLevels: [42],
    x: 1807,
    y: 3626,
  },
  {
    name: "Cooltrainer Jody",
    numPokemon: 1,
    pokemonLevels: [42],
    x: 1542,
    y: 3474,
  },
  {
    name: "Cooltrainer Berke",
    numPokemon: 1,
    pokemonLevels: [42],
    x: 1719,
    y: 3474,
  },
  {
    name: "Norman",
    numPokemon: 6,
    pokemonLevels: [44, 44, 47, 44, 44, 50],
    x: 1632,
    y: 3322,
  },

  // Lavaridge Gym
  {
    name: "Kindler Jeff",
    numPokemon: 2,
    pokemonLevels: [35, 35],
    x: 2179,
    y: 1469,
  },
  {
    name: "Kindler Jace",
    numPokemon: 1,
    pokemonLevels: [36],
    x: 2036,
    y: 1484,
    tooltipPosition: TooltipPosition.Bottom,
  },
  {
    name: "Hiker Eli",
    numPokemon: 1,
    pokemonLevels: [36],
    x: 2036,
    y: 1453,
  },
  {
    name: "Kindler Cole",
    numPokemon: 1,
    pokemonLevels: [36],
    x: 1741,
    y: 1420,
  },
  {
    name: "Cooltrainer Gerald",
    numPokemon: 1,
    pokemonLevels: [36],
    x: 1724,
    y: 1436,
    tooltipPosition: TooltipPosition.Left,
  },
  {
    name: "Kindler Axle",
    numPokemon: 1,
    pokemonLevels: [36],
    x: 1741,
    y: 1356,
  },
  {
    name: "Kindler Keegan",
    numPokemon: 1,
    pokemonLevels: [36],
    x: 2019,
    y: 1293,
  },
  {
    name: "Battle Girl Danielle",
    numPokemon: 1,
    pokemonLevels: [36],
    x: 1773,
    y: 1229,
  },
  {
    name: "Flannery",
    numPokemon: 6,
    pokemonLevels: [38, 42, 38, 38, 38, 47],
    x: 1899,
    y: 1341,
  },

  // Fortree Gym
  {
    name: "Bird Keeper Humberto",
    numPokemon: 1,
    pokemonLevels: [48],
    x: 5398,
    y: 862,
  },
  {
    name: "Bird Keeper Jared",
    numPokemon: 3,
    pokemonLevels: [44, 44, 44],
    x: 5398,
    y: 719,
  },
  {
    name: "Picnicker Ashley",
    numPokemon: 3,
    pokemonLevels: [44, 44, 44],
    x: 5414,
    y: 766,
  },
  {
    name: "Camper Flint",
    numPokemon: 2,
    pokemonLevels: [47, 47],
    x: 5494,
    y: 654,
    tooltipPosition: TooltipPosition.Bottom,
  },
  {
    name: "Bird Keeper Edwardo",
    numPokemon: 2,
    pokemonLevels: [47, 47],
    x: 5478,
    y: 623,
  },
  {
    name: "Bird Keeper Darius",
    numPokemon: 1,
    pokemonLevels: [48],
    x: 5349,
    y: 653,
  },
  {
    name: "Winona",
    numPokemon: 6,
    pokemonLevels: [47, 48, 47, 47, 50, 53],
    x: 5574,
    y: 526,
  },

  // Mossdeep Gym
  {
    name: "Psychic Preston",
    numPokemon: 1,
    pokemonLevels: [57],
    x: 11232,
    y: 1174,
  },
  {
    name: "Psychic Maura",
    numPokemon: 1,
    pokemonLevels: [57],
    x: 11282,
    y: 1760,
  },
  {
    name: "Psychic Samantha",
    numPokemon: 1,
    pokemonLevels: [57],
    x: 11280,
    y: 1661,
    tooltipPosition: TooltipPosition.Bottom,
  },
  {
    name: "Psychic Blake",
    numPokemon: 1,
    pokemonLevels: [57],
    x: 11296,
    y: 1616,
  },
  {
    name: "Psychic Macey",
    numPokemon: 1,
    pokemonLevels: [57],
    x: 11616,
    y: 1695,
  },
  {
    name: "Gentleman Clifford",
    numPokemon: 1,
    pokemonLevels: [57],
    x: 11568,
    y: 1694,
    tooltipPosition: TooltipPosition.Bottom,
  },
  {
    name: "Hex Maniac Kathleen",
    numPokemon: 1,
    pokemonLevels: [57],
    x: 11570,
    y: 1664,
    tooltipPosition: TooltipPosition.Left,
  },
  {
    name: "Psychic Nicholas",
    numPokemon: 1,
    pokemonLevels: [57],
    x: 11617,
    y: 1648,
  },
  {
    name: "Gentleman Nate",
    numPokemon: 1,
    pokemonLevels: [57],
    x: 11361,
    y: 1424,
    tooltipPosition: TooltipPosition.Right,
  },
  {
    name: "Psychic Virgil",
    numPokemon: 1,
    pokemonLevels: [57],
    x: 11312,
    y: 1438,
  },
  {
    name: "Hex Maniac Sylvia",
    numPokemon: 1,
    pokemonLevels: [57],
    x: 11329,
    y: 1373,
    tooltipPosition: TooltipPosition.Left,
  },
  {
    name: "Psychic Hannah",
    numPokemon: 1,
    pokemonLevels: [57],
    x: 11313,
    y: 1342,
  },
  {
    name: "Tate & Liza",
    numPokemon: 6,
    pokemonLevels: [65, 65, 65, 68, 65, 68],
    x: 11592,
    y: 1405,
  },

  // Sootopolis Gym
  {
    name: "Beauty Connie",
    numPokemon: 1,
    pokemonLevels: [63],
    x: 8631,
    y: 2623,
    tooltipPosition: TooltipPosition.Bottom,
  },
  {
    name: "Lass Andrea",
    numPokemon: 1,
    pokemonLevels: [63],
    x: 8598,
    y: 2591,
  },
  {
    name: "Lady Daphne",
    numPokemon: 2,
    pokemonLevels: [62, 62],
    x: 8582,
    y: 2527,
    tooltipPosition: TooltipPosition.Left,
  },
  {
    name: "Pokéfan Annika",
    numPokemon: 2,
    pokemonLevels: [62, 62],
    x: 8646,
    y: 2527,
    tooltipPosition: TooltipPosition.Right,
  },
  {
    name: "Beauty Tiffany",
    numPokemon: 2,
    pokemonLevels: [62, 62],
    x: 8566,
    y: 2416,
    tooltipPosition: TooltipPosition.Left,
  },
  {
    name: "Lass Crissy",
    numPokemon: 2,
    pokemonLevels: [62, 62],
    x: 8550,
    y: 2447,
    tooltipPosition: TooltipPosition.Left,
  },
  {
    name: "Pokéfan Bethany",
    numPokemon: 3,
    pokemonLevels: [56, 59, 62],
    x: 8599,
    y: 2447,
    tooltipPosition: TooltipPosition.Bottom,
  },
  {
    name: "Beauty Olivia",
    numPokemon: 3,
    pokemonLevels: [56, 59, 62],
    x: 8629,
    y: 2431,
  },
  {
    name: "Lady Brianna",
    numPokemon: 1,
    pokemonLevels: [63],
    x: 8679,
    y: 2431,
    tooltipPosition: TooltipPosition.Right,
  },
  {
    name: "Beauty Bridget",
    numPokemon: 1,
    pokemonLevels: [63],
    x: 8661,
    y: 2462,
    tooltipPosition: TooltipPosition.Right,
  },
  {
    name: "Juan",
    numPokemon: 6,
    pokemonLevels: [65, 65, 65, 74, 69, 69],
    x: 8343,
    y: 2353,
  },
];
